import { pxToEm } from 'util/pxToEm';
import { Box, Typography, CircularProgress } from '@mui/material';
import React, { ReactElement } from 'react';
import { NotificationDto } from 'services/api/apis/notifications';
import { NotificationItem } from '../NotificationItem';

export interface NotificationListProps {
  notifications: NotificationDto[];
  isLoading: boolean;
  onNotificationClick: (notification: NotificationDto) => void;
}

export const NotificationList = ({
  notifications,
  isLoading,
  onNotificationClick,
}: NotificationListProps): ReactElement => {
  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (notifications.length === 0) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%"
        flexDirection="column"
      >
        <Typography
          sx={{
            fontSize: pxToEm(16),
            color: theme => theme.palette.text.secondary,
          }}
        >
          No notifications
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      flex={1}
      sx={{
        mt: 16,
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          width: '8px',
        },
        '&::-webkit-scrollbar-track': {
          background: '#f1f1f1',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#888',
          borderRadius: '4px',
        },
      }}
    >
      {notifications.map(notification => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          onClick={onNotificationClick}
        />
      ))}
    </Box>
  );
};

